var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Ph_home"},[_c('Banner'),_c('FantasyNews'),_c('CharacterIntroduction'),_c('FootSwiper'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }